<template>
  <div>
    <TopNav />
    <!-- MAIN CONTENT
    ================================================== -->
    <div class="main-content">
      <!-- HEADER -->
      <div class="header">
        <div class="container">
          <div class="header-body">
            <div class="row align-items-end">
              <Head v-bind:route="'HomeWork'" />
            </div>
          </div>
          <div class="container pt-5">
            <div class="row">
              <div class="col-12 col-lg-12">
                <ul class="nav nav-tabs mb-4">
                  <li class="nav-item">
                    <router-link exact class="nav-link" :to="{ name: 'HomeWork' }">Aktif Sınavlar</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link exact class="nav-link" :to="{ name: 'OldHomeWork' }">Geçmiş Sınavlar</router-link>
                  </li>
                </ul>
              </div>
              <div v-if="message" class="col-12 alert alert-primary text-center">{{ message }}</div>

              <div class="col-12 col-lg-6" v-for="(exam, index) in this.$store.state.exam.old_home_work" :key="index">
                <router-link :to='activeExam(remaining_time_message[index]) ? { name: "HomeWorkDetail", params: {id: exam.id }} : { name: "Home" }' class="card card-fill-lg" :class="activeExam(remaining_time_message[index]) ? '' : 'disabled'">
                  <div class="card-body text-center">
                    <h1 class="mb-3">
                      <i class="fe fe-book-open display-3 mb-4 pb-4"></i><br />
                      {{ exam.sinav_adi }}
                    </h1>
                    <p class="card-text text-muted">
                      <strong>Başlama Tarihi:</strong> {{ dateView(exam.sinav_baslama, null) }}
                      <br />
                      <strong>Bitiş Tarihi:</strong> {{ dateView(exam.sinav_bitis, null) }}
                      <br >
                      <!-- <span v-if="data_is_ready && remaining_time_bar[index]"><strong>{{remaining_text[index] }}:</strong> {{ remaining_time[index] }}</span> -->
                    </p>
                  </div>
                  <div class="card-footer card-footer-boxed">
                    <div class="row align-items-center">
                      <div class="col">
                        <small class="text-muted" v-if="data_is_ready">
                          <i class="fe fe-activity"></i> {{ remaining_time_message[index] }}
                        </small>
                        <small class="text-muted" v-else>
                          <i class="fe fe-clock"></i> Lütfen bekleyiniz...
                        </small>
                      </div>
                      <div class="col-auto">
                        <strong>Sınav süresi:</strong> {{ totalTime(exam) }}
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from '@/components/TopNav'
import Head from '@/components/Head'
import base from '@/mixins/base'
import http from '@/helpers/http' // eslint-disable-line

export default {
  name: 'HomeWork',
  components: { TopNav, Head },
  mixins: [ base ],
  data () {
    return {
      student_id: this.$store.state.auth.student_id,
      message: 'Yükleniyor...',
      remaining_time_bar: {},
      remaining_time: {},
      remaining_time_data: {},
      remaining_time_message: {},
      remaining_text: {},
      data_is_ready: false,
    }
  },
  methods: {
    dateView(date, param=true) {
      return this.dateConverter(date, param) // eslint-disable-line
    },
    activeExam(x) { // eslint-disable-line
      return x == 'Sınava katılabilirsiniz.' || x == 'Sınav devam ediyor.' || x == 'Bu sınav sonlanmış.' ? true : false
      //return true
    },
    totalTime(exam) {
      /*
      let ret = exam.sure
      if ((this.time(exam.sinav_bitis) - this.time(exam.sinav_baslama)) < ret) {
        ret = (this.time(exam.sinav_bitis) - this.time(exam.sinav_baslama))
      }
      return (ret / 60) + ' Dakika'
      */
     return exam.sure + ' Dakika'
    },
    timeControl(start_time, stop_time) {
      let ret = false;
      if (this.time() < this.time(stop_time)) {
        ret = this.time() > this.time(start_time) ? true : false
      }
      return ret
    },
    async examStatus(exam, index) {
      if (this.remaining_time_data[index] !== undefined) { // If we have time
        let started_time = null
        if (this.remaining_time_data[index] != null ) {
          started_time = this.remaining_time_data[index]
        }
        this.remainingBar(exam, index, started_time)
      }/* else if(this.time() > this.time(exam.sinav_baslama) && this.time() < this.time(exam.sinav_bitis)) { // This exam is available and we haven't start time
        await http.post('ev-calismasi-basla', {
          ogrenciID: this.student_id,
          sinavID: exam.SINAV_ID,
          kontrol: true
        }).then(response => {
          if (response.data != undefined && response.data) {
            let started_time = null
            if (response.data[0].baslama_saati != null ) {
              started_time = this.time(response.data[0].baslama_saati)
              this.remaining_time_data[index] = started_time
            } else {
              this.remaining_time_data[index] = null
            }
            this.remainingBar(exam, index, started_time)
          }
        }).catch(error => { // eslint-disable-line
          // throw error
          return false
        });
      }*/ else { // If time is gone
        let started_time = null
        this.remainingBar(exam, index, started_time)
      }
    },
    remainingBar(exam, index, started_time = null) {
      let timex = this.timeCheck(exam.sinav_baslama, exam.sinav_bitis, exam.sure, started_time)
      let time = this.secondToTime(timex)
      this.remaining_time[index] = time.m.toString().padStart(2, '0')  + ':' + time.s.toString().padStart(2, '0')
      this.remaining_text[index] = 'Kalan süre'
      if (time.m > 0 || time.m == 0 && time.s > 0) {
        this.remaining_time_bar[index] = true
        if (this.time() > this.time(exam.sinav_bitis)) {

          this.remaining_time_bar[index] = false
          this.remaining_time_message[index] = 'Bu sınav sonlanmış.'

        } else if (!this.timeControl(exam.sinav_baslama, exam.sinav_bitis)) {

          this.remaining_time_message[index] = 'Sınav henüz başlamadı.'
          this.remaining_time_bar[index] = false

        } else if (started_time == null) {

          this.remaining_time_message[index] = 'Sınava katılabilirsiniz.'
          this.remaining_time_bar[index] = false

        } else {
          this.remaining_time_message[index] = 'Sınav devam ediyor.'
          this.remaining_text[index] = 'Bitiş'
          let new_date = new Date(parseInt(timex) + parseInt(this.time()));
          this.remaining_time[index] = this.dateConverter(new_date * 1000, true, true)

        }
      } else {
        this.remaining_time_bar[index] = false
        this.remaining_time_message[index] = 'Bu sınav sonlanmış.'
      }
    },
  },
  created() {
    this.deviceTimeNConnectionCheck()
    setInterval( () => {
      if (this.$store.state.exam.old_home_work !== null) {
        this.$store.state.exam.old_home_work.forEach((exam, index) => {
          this.examStatus(exam, index)
        });
        setTimeout(() => {
          this.data_is_ready = true
        }, 1000);
      }
    }, 1000)

    if (this.$store.state.exam.old_home_work === null) {
      this.homeWorkData(this.student_id, 'pasif');
      let x = setInterval( () => {
        if (this.$store.state.exam.old_home_work !== null) {
          if (this.$store.state.exam.old_home_work.length == 0) {
            this.message = 'Geçmiş bir sınav kaydı bulunamadı!';
          } else {
            this.message = '';
          }
          clearInterval(x)
        }
      }, 1);
    } else {
      this.message = '';
      if (this.$store.state.exam.old_home_work.length == 0) {
        this.message = 'Geçmiş bir sınav kaydı bulunamadı!';
      }
    }
  },
}
</script>
<style scoped>
.disabled {
  pointer-events: none;
  opacity: 0.6;
}
</style>